// Reference: style set at apps/accelerate/dash/src/index.html
const dashRootFontSize = 14;

export const toRem = (pixelValue: number) => {
    return `${parseFloat((pixelValue / dashRootFontSize).toFixed(4))}rem`;
};
